export var NavigationMixin = {
  methods: {
    openNavMain() {
      this.$store.dispatch('store__app/setShowHeaderNavMain', { flag: true })
    }
  }
}
